import React, { useEffect, useState } from 'react';
import { Grid, Paper, Icon, TextField } from '@mui/material';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { PieChart, Pie, Sector, Cell, Label } from 'recharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faList, faFileVideo, faClipboard } from '@fortawesome/free-solid-svg-icons';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import GetAppIcon from '@mui/icons-material/GetApp';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete } from '@mui/material';
import { DateRangePicker } from '@mui/lab';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
    },
    paper: {
        textAlign: 'center',
        color: theme.palette.text.secondary,
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Adding shadow
    },
}));

const SurveyFragment = () => {
    const classes = useStyles();

    const getDefaultDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = '10';
        const minutes = '00';

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        masterSurveyId: '',
        dueDate: null,
        schedule: getDefaultDateTime(),
        department: [],
        employees: [],
        questions: [{ question: '', options: [{ optionText: '', weightage: '' }] }],
        categories: [],
        createdBy: localStorage.getItem('userId')
    });
    const [surveyMasters, setSurveyMasters] = useState([]);
    const [surveys, setSurveys] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [categorySurvey, setCategorySurvey] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isEdit, setIsEdit] = useState(false);
    const [isList, setIsList] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [isGraph, setIsGraph] = useState(true);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [surveryItem, setSurveyItem] = useState(null);

    useEffect(() => {
        if (surveryItem) {
            handleFetchGraphData(surveryItem);
        }
    }, [startDate, endDate]); // Add formData.company to the dependencies

    const handleCategoryChange = (event, newValue) => {
        setSelectedCategories(newValue);
    };

    const handleDateChange = (newValue) => {
        setDateRange(newValue);
    };

    useEffect(() => {
        fetchSurveyMaster();
        fetchCategorySurvey();
        fetchCompanies();
        fetchDepartments();
    }, []);

    useEffect(() => {
        fetchEmployees();
    }, [formData]); // Add formData.company to the dependencies


    useEffect(() => {
        fetchSurvey(currentPage);
    }, [currentPage]); // Add formData.company to the dependencies

    const fetchDepartments = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/department", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setDepartments(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCompanies = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch("https://beiguru.co.in/admin/companies", requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setCompanies(result))
            .catch((error) => console.error(error));
    }

    const fetchCategorySurvey = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categorySurvey", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => {
                    setCategorySurvey(result);
                    setFormData({ ...formData, categories: result.map(category => ({ name: category._id, weightage: 0 })) });
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const fetchEmployees = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/employees?page=1&limit=10000`;
        if (formData.company) {
            apiUrl += `&companyId=${formData.company}`; // Append company ID if selected
        }
        if (formData.department.length > 0) {
            apiUrl += `&departmentId=${formData.department[formData.department.length - 1]._id}`; // Append company ID if selected
        }
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                setEmployees(result.employees);
            })
            .catch((error) => console.error(error));
    }

    const fetchSurveyMaster = async (currentPage) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/survey-masters`;
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                setSurveyMasters(result);
            })
            .catch((error) => console.error(error));
    }

    const fetchSurvey = async (currentPage) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/surveys`;
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                setSurveys(result);
            })
            .catch((error) => console.error(error));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const scheduleDate = new Date(formData.schedule);
            const dueDate = new Date(formData.dueDate);
            if (dueDate && scheduleDate > dueDate) {
                alert('Schedule date cannot be after the due date.');
            }
            else {
                setIsLoading(true);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));
                myHeaders.append("Content-Type", "application/json");

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify({
                        name: formData.name,
                        department: formData.department,
                        company: formData.company,
                        masterSurveyId: formData.masterSurveyId,
                        employees: formData.employees,
                        dueDate: formData.dueDate,
                        schedule: formData.schedule,
                        categories: formData.categories,
                        questions: formData.questions.map(question => ({
                            question: question.question,
                            options: question.options,
                            category: question.category // Assuming category is part of each question object
                        })),
                        createdBy: formData.createdBy
                    }),
                    redirect: "follow"
                };

                try {
                    const surveyResponse = await fetch(`https://beiguru.co.in/admin/survey`, requestOptions);

                    if (!surveyResponse.ok) {
                        throw new Error('Failed to create survey');
                    }

                    setFormData({
                        name: '',
                        company: '',
                        department: [],
                        company: '',
                        masterSurveyId: '',
                        employees: [],
                        dueDate: null,
                        schedule: getDefaultDateTime(),
                        categories: categorySurvey.map(category => ({ name: category._id, weightage: 0 })),
                        questions: [{ question: '', options: [{ optionText: '', weightage: '' }] }],
                        createdBy: localStorage.getItem('userId')
                    });
                    alert('Survey created successfully');
                    // Handle success
                } catch (error) {
                    console.error('Error creating survey:', error.message);
                    alert('Error creating survey, please try again!');
                    // Handle error
                }
                fetchSurvey();
                setIsLoading(false);
            }
        } catch (error) {
            alert('Error creating survey, please try again!');
            setIsLoading(false);
        }
    };

    const handleEdit = async (material) => {
        const now = new Date(material.schedule);
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours() - 5).padStart(2, '0');
        const minutes = String(now.getMinutes() - 30).padStart(2, '0');
        setFormData({
            name: material.name,
            questions: material.questions,
            department: material.department,
            company: material.company,
            employees: material.employees,
            dueDate: material.dueDate ? new Date(material.dueDate).toISOString().split('T')[0] : '',
            schedule: `${year}-${month}-${day}T${hours}:${minutes}`,
            categories: material.categories,
            createdBy: localStorage.getItem('userId'),
            surveyID: material._id,
        });
        setIsEdit(true);
        await fetchEmployees();
    }

    const handleModify = async (e) => {
        e.preventDefault();
        try {
            const scheduleDate = new Date(formData.schedule);
            const dueDate = new Date(formData.dueDate);
            if (dueDate && scheduleDate > dueDate) {
                alert('Schedule date cannot be after the due date.');
            }
            else {
                setIsLoading(true);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));
                myHeaders.append("Content-Type", "application/json");

                const requestOptions = {
                    method: "PUT",
                    headers: myHeaders,
                    body: JSON.stringify({
                        name: formData.name,
                        department: formData.department,
                        company: formData.company,
                        employees: formData.employees,
                        dueDate: formData.dueDate,
                        schedule: formData.schedule,
                        categories: formData.categories,
                        questions: formData.questions.map(question => ({
                            question: question.question,
                            options: question.options,
                            category: question.category // Assuming category is part of each question object
                        })),
                        createdBy: formData.createdBy
                    }),
                    redirect: "follow"
                };

                try {
                    const surveyResponse = await fetch(`https://beiguru.co.in/admin/survey/${formData.surveyID}`, requestOptions);

                    if (!surveyResponse.ok) {
                        alert('Error updating survey, please try again!');
                        throw new Error('Failed to create survey');
                    }

                    alert('Survey updated successfully');
                    setFormData({
                        name: '',
                        company: '',
                        masterSurveyId: '',
                        department: [],
                        company: '',
                        employees: [],
                        dueDate: null,
                        schedule: getDefaultDateTime(),
                        categories: categorySurvey.map(category => ({ name: category._id, weightage: 0 })),
                        questions: [{ question: '', options: [{ optionText: '', weightage: '' }] }],
                        createdBy: localStorage.getItem('userId')
                    });

                } catch (error) {
                    alert('Error updating survey, please try again!');
                    console.error('Error creating survey:', error.message);
                    // Handle error
                }
                fetchSurvey();
                setIsEdit(false);
                setIsLoading(false);
            }
        } catch (error) {
            alert('Error updating survey, please try again!');
            setIsLoading(false);
        }
    }

    const handleDelete = (courseID) => {
        // Display confirmation popup before deleting
        const isConfirmed = window.confirm("Are you sure you want to delete this survey?");
        if (!isConfirmed) return; // If user cancels, do nothing

        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "DELETE",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch(`https://beiguru.co.in/admin/survey/${courseID}`, requestOptions)
            .then((result) => {
                if (result.ok) {
                    alert('Survey deleted successfully');
                    fetchSurvey();
                }
            }).catch((error) => console.error(error));
    }

    const handleEmployeeChange = (event, newValue) => {
        if (newValue) {
            if (newValue.some(option => option.id === 'select-all')) {
                setFormData((formData) => {
                    var ids = new Set(formData.employees.map(d => d._id));
                    var merged = [...formData.employees, ...employees.filter(d => !ids.has(d._id))];
                    return { ...formData, employees: merged };
                });
            } else {

                setFormData((formData) => {
                    let removeCount = 0;
                    let addCount = 0;
                    formData.employees.forEach(preObj => {
                        const found = newValue.find(newObj => JSON.stringify(newObj) == JSON.stringify(preObj));
                        if (!found) {
                            removeCount++;
                        }
                    });
                    newValue.forEach(newObj => {
                        const found = formData.employees.find(prevObj => JSON.stringify(prevObj) == JSON.stringify(newObj));
                        if (!found) {
                            addCount++;
                        }
                    });
                    var ids = new Set(formData.employees.map(d => d._id));
                    var merged = [...formData.employees, ...newValue.filter(d => !ids.has(d._id))];
                    return { ...formData, employees: removeCount > 0 ? newValue.filter(d => ids.has(d._id)) : merged };
                });
            }
        }
    };

    const handleWeightageChange = (e, categoryIndex) => {
        const newCategories = [...formData.categories];
        newCategories[categoryIndex].weightage = parseInt(e.target.value) || 0; // Convert to integer
        console.log(newCategories);
        setFormData({ ...formData, categories: newCategories });
    };


    const handleFetchGraphData = (material) => {
        setSurveyItem(material);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/averageWeightage/${material._id}`;
        if (startDate && endDate) {
            apiUrl += `?startDate=${new Date(startDate).toISOString()}&endDate=${new Date(endDate).toISOString()}`;
        }
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                const mergedCategories = result.map(category1 => {
                    const matchingCategory = material.categories.find(category2 => category1.categoryId === category2.name);
                    if (matchingCategory) {
                        return {
                            categoryName: category1.categoryName,
                            categoryId: category1.categoryId,
                            Current: category1.averageWeightage,
                            Target: parseInt(matchingCategory.weightage),
                            _id: matchingCategory._id
                        };
                    } else {
                        return null; // Handle case where category from array1 doesn't match any category from array2
                    }
                }).filter(category => category !== null); // Filter out null entries
                // Assuming currentValues is already defined

                console.log(mergedCategories);
                setGraphData(mergedCategories);
            })
            .catch((error) => {
                setGraphData([]);
                console.error(error)
            });
        setIsGraph(false);
    };

    const handleDownloadAnswers = async (surveyId) => {
        try {
            const response = await fetch(`https://beiguru.co.in/surveyAnswers/${surveyId}`);
            const data = await response.json();

            // Define the CSV content
            let csvContent = 'Students Name,Students Email,Students Department,Students School,Survey Question,Selected Option,Selected Weightage\n';

            // Loop through each survey answer and add to the CSV content
            data.forEach(answer => {
                csvContent += `"${answer.employeeName}","${answer.employeeEmail}","${answer.employeeDepartment}","${answer.employeeCompany}","${answer.surveyQuestion}","${answer.selectedOption}","${answer.selectedWeightage}"\n`;
            });

            // Create a Blob object with the CSV data
            const blob = new Blob([csvContent], { type: 'text/csv' });

            // Create a temporary anchor element
            const anchor = document.createElement('a');
            anchor.href = window.URL.createObjectURL(blob);
            anchor.download = 'survey_answers.csv';
            anchor.click();

        } catch (error) {
            console.error('Error downloading answers:', error);
            // Handle error
        }
    };

    const options = [
        { id: 'select-all', firstName: 'Select', lastName: 'All' }, // Select All option
        ...employees
    ];

    const filteredData = selectedCategories.length > 0
        ? graphData.filter(item =>
            selectedCategories.some(category => category._id === item.categoryId))
        : graphData;
    const averageScore = filteredData.map(category => category.Current).reduce((acc, cur, _, arr) => acc + cur / arr.length, 0);

    return (<Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Container fluid style={{ height: '100%' }}>
            {isGraph ? <Row>
                <Col xs={12} style={{ flex: 1, height: '90vh', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%' }}>
                        {surveys.length > 0 ? <Table striped bordered hover >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Total Questions</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Map through companies data to display each company */}
                                {surveys.map(material => {
                                    return <tr key={material._id}>
                                        <td style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }} onClick={() => handleFetchGraphData(material)}>
                                            <div style={{
                                                backgroundColor: new Date() < new Date(material.schedule)
                                                    ? 'grey'
                                                    : new Date() >= new Date(material.schedule) && new Date() <= new Date(material.dueDate)
                                                        ? 'green'
                                                        : 'red',
                                                width: '10px',
                                                height: '50px'
                                            }} />
                                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: '10px', justifyContent: 'space-evenly' }}>
                                                {material.name}
                                                <p style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>{material._id}</p>
                                            </div>
                                        </td>
                                        <td onClick={() => handleFetchGraphData(material)}>{material.questions.length}</td>
                                        <td>
                                            <EditNoteIcon onClick={() => handleEdit(material)} style={{ color: 'green', cursor: 'pointer' }} />
                                            <DeleteSweepIcon onClick={() => handleDelete(material._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            <GetAppIcon onClick={() => handleDownloadAnswers(material._id)} style={{ color: 'blue', cursor: 'pointer' }} />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table> : <div style={{ margin: '20px', textAlign: 'center' }}>No survey found, please try again!</div>}
                    </div>
                    <div style={{ flex: 1 }} />
                    <nav aria-label="Courses pagination">
                        <ul className="pagination">
                            {[...Array(totalPages).keys()].map((page) => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                        {page + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </Col>
                <Col xs={4} style={{ height: '82vh', overflowY: 'auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h4>{isEdit ? 'Edit' : 'Create'} Survey</h4>
                        <Button variant="secondary" onClick={() => {
                            setFormData({
                                name: '',
                                company: '',
                                masterSurveyId: '',
                                department: [],
                                company: '',
                                employees: [],
                                dueDate: null,
                                schedule: getDefaultDateTime(),
                                categories: categorySurvey.map(category => ({ name: category._id, weightage: 0 })),
                                questions: [{ question: '', options: [{ optionText: '', weightage: '' }] }],
                                createdBy: localStorage.getItem('userId')
                            });
                            setIsEdit(false);
                        }}>Cancel</Button>
                    </div>
                    <Form.Group controlId={`formsurveyname`} style={{ marginBottom: '10px' }}>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Survey Name</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '5px' }}
                            type="text"
                            placeholder="Enter the survey name"
                            value={formData.name}
                            onChange={(e) => {
                                setFormData({ ...formData, name: e.target.value });
                            }}
                        />
                    </Form.Group>
                    {isEdit ? null : <Form.Group controlId="formCompanyFilter" style={{ marginBottom: '10px' }}>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Survey Template</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '5px' }}
                            as="select"
                            value={formData.masterSurveyId}
                            onChange={(e) => {
                                setFormData({ ...formData, masterSurveyId: e.target.value });
                            }}>
                            <option value="">Select a survey template</option>
                            {surveyMasters.map(company => (
                                <option key={company._id} value={company._id}>{company.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>}
                    <div style={{ height: '5px' }} />
                    <Form.Group controlId="formCompanyFilter" style={{ marginBottom: '10px' }}>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>School Name</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '5px' }}
                            as="select"
                            value={formData.company}
                            onChange={(e) => {
                                setFormData({ ...formData, company: e.target.value, department: [], employees: [] });
                            }}>
                            <option value="">Select a company</option>
                            {companies.map(company => (
                                <option key={company._id} value={company._id}>{company.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <div style={{ height: '5px' }} />
                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Department Name</Form.Label>
                    <Autocomplete
                        multiple
                        id="formDepartmentFilter"
                        options={departments}
                        value={formData.department}
                        getOptionLabel={(option) => option.name}
                        onChange={(event, newValue) => {
                            setFormData({ ...formData, department: newValue });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined" // Set background color to blue
                            />
                        )}
                    />
                    <div style={{ height: '5px' }} />
                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Students Name</Form.Label>
                    <Autocomplete
                        multiple
                        id="formEmployeeFilter"
                        options={options}
                        getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                        value={formData.employees}
                        onChange={handleEmployeeChange}
                        filterSelectedOptions
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Students"
                                variant="outlined"
                            />
                        )}
                    />
                    <div style={{ height: '10px' }} />
                    <Form.Group controlId="dueDate">
                        <Form.Label>Due Date:</Form.Label>
                        <Form.Control
                            type="date"
                            value={formData.dueDate}
                            onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                            required
                            style={{ marginBottom: '10px' }}
                        />
                    </Form.Group>
                    <div style={{ height: '10px' }} />
                    <Form.Group controlId="scheduleDate">
                        <Form.Label>Schedule Survey:</Form.Label>
                        <Form.Control
                            type="datetime-local"
                            value={formData.schedule}
                            onChange={(e) => setFormData({ ...formData, schedule: e.target.value })}
                            required
                            style={{ marginBottom: '10px' }}
                        />
                    </Form.Group>
                    <div style={{ height: '10px' }} />
                    {formData.masterSurveyId ? <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <p>**Editing of survey is available once the survey has been created.</p>
                    </div> : <div>
                        {formData.categories.map((category, categoryIndex) => (
                            <div key={categoryIndex} style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                <Form.Group controlId={`formCategoryName-${categoryIndex}`}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Category Name</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        disabled
                                        value={categorySurvey.find((e) => e._id == category.name).name}
                                        type="text" />
                                </Form.Group>
                                <div style={{ width: '5px' }} />
                                <Form.Group controlId={`formWeightage-${categoryIndex}`}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Weightage</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        type="number"
                                        value={category.weightage}
                                        onChange={(e) => handleWeightageChange(e, categoryIndex)} />
                                </Form.Group>
                            </div>
                        ))}
                        <div style={{ height: '10px' }} />
                        {formData.questions.map((question, questionIndex) => (
                            <div key={questionIndex} style={{ backgroundColor: '#F6F6F6', marginBottom: '10px', padding: '10px', borderRadius: '5px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' }}>
                                    <h5 style={{ fontWeight: '500', borderRadius: '20px', alignSelf: 'center' }}>Question {questionIndex + 1}</h5>
                                    <DeleteSweepIcon onClick={() => {
                                        const newQuestions = [...formData.questions];
                                        newQuestions.splice(questionIndex, 1); // Remove question
                                        setFormData({ ...formData, questions: newQuestions });
                                    }} style={{ color: 'red', cursor: 'pointer' }} />
                                </div>

                                <Form.Group controlId="formCategory">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Category</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        as="select"
                                        value={question.category}
                                        onChange={(e) => {
                                            const newQuestions = [...formData.questions];
                                            newQuestions[questionIndex].category = e.target.value;
                                            setFormData({ ...formData, questions: newQuestions });
                                        }}>
                                        <option value="">Select a category</option>
                                        {categorySurvey.map(category => (
                                            <option key={category._id} value={category._id}>{category.name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId={`formQuestion-${questionIndex}`}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Question</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        type="text"
                                        as="textarea"
                                        rows={2}
                                        placeholder="Enter the question"
                                        value={question.question}
                                        onChange={(e) => {
                                            const newQuestions = [...formData.questions];
                                            newQuestions[questionIndex].question = e.target.value;
                                            setFormData({ ...formData, questions: newQuestions });
                                        }}
                                    />
                                </Form.Group>
                                {/* Options */}
                                <Form.Group controlId={`formOptions-${questionIndex}`}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Options</Form.Label>
                                    {question.options.map((option, optionIndex) => (
                                        <div key={optionIndex} className="mb-3" style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                            <Form.Control
                                                className="w-70"
                                                style={{ width: '70%', borderRadius: '20px' }}
                                                type="text"
                                                as="textarea"
                                                rows={1}
                                                value={option.optionText}
                                                placeholder={`Option ${optionIndex + 1}`}
                                                onChange={(e) => {
                                                    const newOptions = [...formData.questions[questionIndex].options];
                                                    newOptions[optionIndex].optionText = e.target.value;
                                                    setFormData(prevState => {
                                                        const updatedQuestions = [...prevState.questions];
                                                        updatedQuestions[questionIndex].options = newOptions;
                                                        return { ...prevState, questions: updatedQuestions };
                                                    });
                                                }}
                                            />
                                            <div style={{ width: '5px' }} />
                                            <Form.Control
                                                className="w-30"
                                                style={{ width: '30%', borderRadius: '20px' }}
                                                type="number"
                                                value={option.weightage}
                                                placeholder={`Weight`}
                                                onChange={(e) => {
                                                    const newOptions = [...formData.questions[questionIndex].options];
                                                    newOptions[optionIndex].weightage = e.target.value;
                                                    setFormData(prevState => {
                                                        const updatedQuestions = [...prevState.questions];
                                                        updatedQuestions[questionIndex].options = newOptions;
                                                        return { ...prevState, questions: updatedQuestions };
                                                    });
                                                }}
                                            />
                                            <div style={{ width: '5px' }} />
                                            <DeleteSweepIcon onClick={() => {
                                                const newOptions = [...formData.questions[questionIndex].options];
                                                newOptions.splice(optionIndex, 1); // Remove option
                                                setFormData(prevState => {
                                                    const updatedQuestions = [...prevState.questions];
                                                    updatedQuestions[questionIndex].options = newOptions;
                                                    return { ...prevState, questions: updatedQuestions };
                                                });
                                            }} style={{ color: 'red', cursor: 'pointer' }} />
                                        </div>
                                    ))}
                                </Form.Group>
                                {/* Add option button */}
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    style={{ fontWeight: '600', borderRadius: '20px', marginBottom: '10px' }}
                                    onClick={() => {
                                        const newOptions = [...formData.questions[questionIndex].options, { optionText: '', weightage: '' }];
                                        setFormData(prevState => {
                                            const updatedQuestions = [...prevState.questions];
                                            updatedQuestions[questionIndex].options = newOptions;
                                            return { ...prevState, questions: updatedQuestions };
                                        });
                                    }}
                                >
                                    Add Option
                                </Button>
                                {/* Remove question button */}

                            </div>
                        ))}
                        {/* Add question button */}
                        <Button
                            variant="outline-primary"
                            size="sm"
                            elevation={3}
                            className="w-100"
                            style={{ fontWeight: '600', borderRadius: '20px', marginBottom: '10px' }}
                            onClick={() => {
                                setFormData(prevState => ({
                                    ...prevState,
                                    questions: [...prevState.questions, { question: '', options: [{ optionText: '', weightage: '' }] }]
                                }));
                            }}
                        >
                            Add Question
                        </Button>
                    </div>}
                    <Button
                        onClick={isEdit ? handleModify : handleSubmit}
                        style={{ fontWeight: '600', borderRadius: '20px', marginTop: '5px' }}
                        elevation={3}
                        className="w-100"
                        variant="primary"
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : null}
                        {isEdit ? 'Modify' : 'Create'} Survey
                    </Button>
                </Col>
            </Row> : <Row>
                <Col xs={12} style={{ overflowY: 'scroll', flex: 1, width: '100%', height: '83vh', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%', paddingLeft: '20px', paddingRight: '20px', marginBottom: '15px', marginTop: '10px', justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                        <Autocomplete
                            multiple
                            id="categories"
                            options={categorySurvey}
                            sx={{ height: '50px' }}
                            getOptionLabel={(option) => option.name}
                            value={selectedCategories}
                            onChange={handleCategoryChange}
                            renderInput={(params) => <TextField {...params} label="Select Categories" placeholder="Select Categories" />}
                        />
                        <div style={{ width: '10px' }} />
                        <Form.Group controlId="startDate">
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => {
                                    setStartDate(e.target.value);
                                    setEndDate(''); // Reset end date
                                }}
                                required
                                style={{ height: '56px' }}
                            />
                        </Form.Group>
                        <div style={{ width: '10px' }} />
                        <Form.Group controlId="endDate">
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                required
                                style={{ height: '56px' }}
                                min={startDate} // Disable all previous dates
                            />
                        </Form.Group>
                        <div style={{ flex: 1 }} />
                        <div>
                            <Button
                                variant="outline-primary"
                                style={{ fontWeight: '600', borderRadius: '5px', marginLeft: '10px' }}
                                onClick={() => {
                                    const input = document.getElementById('divToPrint');

                                    // Get the width and height of the content to set the canvas size
                                    const width = input.offsetWidth;
                                    const height = input.offsetHeight;

                                    html2canvas(input, { scrollY: -window.scrollY, scale: 2, width: width, height: height })
                                        .then((canvas) => {
                                            const imgData = canvas.toDataURL('image/jpeg', 1.0); // Use JPEG format for better compression
                                            const pdf = new jsPDF('p', 'px', [width, height]); // Set page size as per content size
                                            pdf.addImage(imgData, 'JPEG', 0, 0, width, height);
                                            pdf.save('download.pdf');
                                        });
                                }}>
                                Download PDF
                            </Button>
                            <Button
                                style={{ fontWeight: '600', borderRadius: '5px', marginLeft: '10px' }}
                                elevation={3}
                                variant="primary"
                                type="submit"
                                disabled={isLoading}
                                onClick={(event) => {
                                    event.preventDefault();
                                    setIsGraph(true);
                                }}>Cancel</Button>
                        </div>
                    </div>
                    <div style={{ height: '10px' }} />
                    <div id='divToPrint'>
                        <Paper className={classes.paper} style={{ padding: '20px', marginTop: '10px' }}>
                            <BarChart
                                width={1060}
                                height={500}
                                data={filteredData}
                                margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="categoryName" />
                                <YAxis domain={[0, 100]} /> {/* Set YAxis domain to [0, 100] */}
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="Current" fill="#8884d8" />
                                <Bar dataKey="Target" fill="#82ca9d" />
                            </BarChart>
                        </Paper>
                        <div style={{ height: '10px' }} />
                        <Paper className={classes.paper} style={{ padding: '20px', width: '1100px', marginTop: '10px', marginBottom: '20px' }}>
                            <div style={{ height: '12px' }} />
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', flex: 2, alignItems: 'center' }}>
                                    <h4 style={{ fontSize: '18px', fontWeight: 'bold', color: 'black', fontFamily: 'Noto Sans', marginBottom: '10px' }}>Your Security Culture Score</h4>
                                    <h4 style={{ fontSize: '34px', fontWeight: 'bold', color: '#8884d8', fontFamily: 'Noto Sans', marginBottom: '20px' }}>{Math.floor(averageScore)}</h4>
                                    <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: 'black', fontFamily: 'Noto Sans', marginBottom: '5px' }}>Security Culture Index</h4>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'end', marginRight: '20px' }}>90-100</h4>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'start' }}>Excellent</h4>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'end', marginRight: '20px' }}>80-89</h4>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'start' }}>Good</h4>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'end', marginRight: '20px' }}>70-79</h4>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'start' }}>Moderate</h4>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'end', marginRight: '20px' }}>60-69</h4>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'start' }}>Mediocre</h4>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'end', marginRight: '20px' }}>0-59</h4>
                                        <h4 style={{ flex: 1, fontSize: '12px', color: 'black', fontFamily: 'Noto Sans', textAlign: 'start' }}>Poor</h4>
                                    </div>
                                </div>

                                <BarChart
                                    width={800}
                                    height={500}
                                    layout="vertical"
                                    data={filteredData}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis type="number" domain={[0, 100]} />
                                    <YAxis dataKey="categoryName" type="category" />
                                    <Tooltip />
                                    <Bar
                                        dataKey="Current"
                                        fill="#8884d8"
                                        label={{
                                            position: 'right',
                                            fill: 'black', // Set label color to black
                                            fontSize: 20, // Set label font size
                                            fontWeight: 'bold' // Set label font weight
                                        }}
                                    />
                                </BarChart>
                            </div>
                            <div style={{ height: '10px' }} />
                        </Paper>
                    </div>
                </Col>
            </Row>}
        </Container>
    </Grid >
    );
}

export default SurveyFragment;